(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[549],{

/***/ 4485:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/[tag]",
      function () {
        return __webpack_require__(7756);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8420);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6159);


const DateFormatter = (param)=>{
    let { dateString  } = param;
    const date = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateString);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
        dateTime: dateString,
        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, "LLLL	d, yyyy")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateFormatter);


/***/ }),

/***/ 4396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* reexport */ PostCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/DateFormatter.tsx
var DateFormatter = __webpack_require__(2074);
// EXTERNAL MODULE: ./components/Tags/Tags.tsx + 1 modules
var Tags = __webpack_require__(2459);
;// CONCATENATED MODULE: ./components/PostCard/PostCard.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-weight: bold;\n  line-height: 32px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  color: ",
        ";\n  font-size: 16px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n\n  * {\n    color: ",
        ";\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}





const StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2747bfd-0"
})(_templateObject());
const StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-d2747bfd-1"
})(_templateObject1(), (props)=>props.theme.palette.colors.typography[1000]);
const StyledDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2747bfd-2"
})(_templateObject2(), (props)=>props.theme.palette.colors.typography[900]);
const StyledPreviewText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2747bfd-3"
})(_templateObject3(), (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.typography[1000]);
const StyledTags = (0,styled_components_browser_esm/* default */.ZP)(Tags/* Tags */.$).withConfig({
    componentId: "sc-d2747bfd-4"
})(_templateObject4());
function PostCard(param) {
    let { item  } = param;
    const { title , name , date , content , slug , excerpt , tags  } = item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/posts/".concat(slug),
                style: {
                    textDecoration: "none"
                },
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDate, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateFormatter/* default */.Z, {
                                dateString: date
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPreviewText, {
                            dangerouslySetInnerHTML: {
                                __html: excerpt
                            }
                        })
                    ]
                })
            }),
            tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTags, {
                items: tags
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/PostCard/index.ts



/***/ }),

/***/ 2459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Tags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Tags/Tag.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 8px;\n  border: 2px solid ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  transition: background 300ms ease;\n  border-radius: 100px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 13px;\n\n  &:hover {\n    border: 2px solid ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65c913ad-0"
})(_templateObject(), (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.purple[700], (props)=>props.theme.palette.colors.purple[700]);
const Tag = (param)=>{
    let { className , text , path  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        style: {
            textDecoration: "none",
            color: "unset"
        },
        className: className,
        title: text,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
            children: text
        })
    });
};

;// CONCATENATED MODULE: ./components/Tags/Tags.tsx

function Tags_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n"
    ]);
    Tags_templateObject = function() {
        return data;
    };
    return data;
}




const Tags_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8efdce6-0"
})(Tags_templateObject());
const Tags = (param)=>{
    let { className , items  } = param;
    if (!items) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags_StyledContainer, {
        className: className,
        children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                text: item,
                path: "/tag/".concat(item)
            }, item))
    });
};


/***/ }),

/***/ 8719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ BackButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/neutral/ChevronLeft.jsx

const ChevronLeft = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5 5.5 8 10l4.5 4.5",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/neutral/BackButton.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  color: #2f426c;\n  font-weight: 600;\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n    background: none;\n    padding: 0;\n    margin: 0;\n    outline: none;\n    box-shadow: none;\n    cursor: pointer;\n    font: inherit;\n    color: inherit;\n\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}





const StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronLeft).withConfig({
    componentId: "sc-ba5031d8-0"
})(_templateObject());
const StyledTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ba5031d8-1"
})(_templateObject2(), (props)=>props.$color && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), props.$color));
const StyledContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ba5031d8-2"
})(_templateObject3());
const BackButton = (param)=>{
    let { className , color ="#2f426c"  } = param;
    const router = (0,next_router.useRouter)();
    const handleBack = ()=>{
        router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        onClick: handleBack,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                color: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                $color: color,
                children: "Back"
            })
        ]
    });
};


/***/ }),

/***/ 267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getSizes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 680px;\n  margin: 0 auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const getSizes = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());


/***/ }),

/***/ 7756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9521);
/* harmony import */ var _zenury_ui_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var _components_PostCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4396);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(267);
/* harmony import */ var _components_neutral_BackButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8719);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0;\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 28px 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}







const StyledPosts = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a948a27-0"
})(_templateObject(), _components_styles__WEBPACK_IMPORTED_MODULE_5__/* .getSizes */ .T);
const StyledDivider = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_zenury_ui_components__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .iz).withConfig({
    componentId: "sc-3a948a27-1"
})(_templateObject1());
var __N_SSG = true;
function Tag(param) {
    let { allPosts  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPosts, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_neutral_BackButton__WEBPACK_IMPORTED_MODULE_6__/* .BackButton */ .x, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: allPosts.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_PostCard__WEBPACK_IMPORTED_MODULE_4__/* .PostCard */ .y, {
                                item: item
                            }),
                            i < allPosts.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDivider, {})
                        ]
                    }, item.slug))
            })
        ]
    });
}


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(880)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [898,358,774,888,179], function() { return __webpack_exec__(4485); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);